<section>
  <div class="md:grid md:grid-cols-2 h-screen">
    <!-- Left Column -->
    <div class="hidden md:flex flex-col px-36 md:px-5 lg:px-28 xl:px-28 2xl:px-36 py-24 relative">
      <div class="inline-block">
        <img src="/assets/logo-horizontal.png" alt="Royal Hospital Logo" />

      </div>
      <div class="flex-grow flex flex-col justify-center relative">
        <img src="/assets/login-background.png" alt="" class="absolute inset-0 w-full h-full object-cover -ml-36" />
        <div class="relative z-10">
          <p class="font-semibold text-[2.5rem] text-[#8F8F8F] mb-0 pb-0">
            {{ greetingMessage }}
          </p>
          <p class="font-semibold text-[2.5rem] leading-tight mt-[20px]">
            Welcome to Royal Hospital
          </p>
        </div>
      </div>
      <div class="mt-auto">
        <img src="/assets/purple-logo.png" alt="Purple Software Logo" />
        <div class="flex flex-row flex-wrap gap-1">
          <div><a class="no-underline z-10" href="https://www.purple.lk/?utm_source=Home Nursing Management System"
              target="_blank" rel="noopener">
              <p class="font-bold text-xs text-[#64748B]">
                Powered by <span class="text-[#6C066D]">Purple Software</span>
              </p>
            </a></div>
          <p class="text-xs text-[#5E5E5E]">| Version 1.5.0</p>
        </div>
      </div>
    </div>

    <div class="bg-[#E7F1FF] flex flex-col justify-between h-screen">
      <div class="flex justify-center md:justify-end space-x-10 pt-5 md:pr-10">
        <p routerLink="/nurse-login" class="text-[#526ED3] font-extrabold text-base no-underline cursor-pointer">
          Nurse Login
        </p>
        <p routerLink="/admin-login" class="text-[#526ED3] font-extrabold text-base no-underline cursor-pointer">
          Admin Login
        </p>
      </div>

      <!-- Patient Login Form -->
      <div class="flex justify-center items-center h-full">
        <div class="bg-white rounded-xl px-8 pb-8 pt-3 w-[300px] lg:w-[420px]">
          <h2 class="text-2xl font-bold text-[#3E4A58] mb-4 mt-1 text-start">
            Client Login
          </h2>
          <form class="space-y-4" [formGroup]="loginForm" (ngSubmit)="submit()">
            <label tuiLabel class="tui-space_bottom-4">
              <tui-input formControlName="username">Email Address <input tuiTextfieldLegacy type="email" /></tui-input>
              <tui-error formControlName="username" class="mb-3" [error]="[] | tuiFieldError | async" />
            </label>
            <label tuiLabel class="tui-space_bottom-4">
              <tui-input-password formControlName="password">Password <input tuiTextfieldLegacy
                  type="password" /></tui-input-password>
              <tui-error formControlName="password" class="mb-3" [error]="[] | tuiFieldError | async" />
            </label>
            <!-- @if (authError !== '') {
                        <tui-error class="mb-3" [error]="authError" />
                        } -->
            <div class="mb-4 text-left">
              <p routerLink="/forgot-password/client"
                class="text-[#526ED3] cursor-pointer font-medium text-base underline decoration-dotted underline-offset-4">
                Forgot Password?
              </p>
            </div>
            <re-captcha [siteKey]="siteKey" (resolved)="onCaptchaResolved($event)" [size]="'invisible'"></re-captcha>
            <button appearance="primary" tuiButton type="submit" [disabled]="isLoading" [disabled]="isLoading"
              class="w-full bg-[#285CA5] text-white text-base font-bold py-4 rounded-xl border-none outline-none">
              <span>{{ isLoading ? "Signing in..." : "Sign In" }}</span>
            </button>
            <div *ngIf="!isOnline" class="flex justify-center items-center mt-2 mb-0 pb-0">
              <p class="text-red-600 text-base">
                Network error, please try again later.
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>